import { loadNg1Module, ngmodule } from "../../bootstrap/ngmodule";
import { taskComponent } from './task.component';
import { taskListComponent } from './task.list.component';
import { taskState, taskListState, taskItemState, taskItemBasicState, taskArchiveState } from "./tasks.states";
import { taskItemComponent } from "./task.item.component";
import { taskItemBasicComponent } from "./task.item.basic.component";
import { taskArchiveComponent } from "./task.archive.component";

const subscriptionAppModule: aboTheme.INgModule = {
    components: { taskComponent, taskListComponent, taskItemComponent, taskItemBasicComponent, taskArchiveComponent },
    states: [ taskState, taskListState, taskItemState, taskItemBasicState, taskArchiveState ],
  };
  
  loadNg1Module(ngmodule, subscriptionAppModule);


// WEBPACK FOOTER //
// ./src/app/modules/tasks/index.ts